<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">
              mdi-arrow-left
            </v-icon>
            {{ $t('select_location') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pb-0">
        <l-autocompleted
          v-model="place_id"
          :items="list_address"
          :open-menu="open_autocompleted"
          item-text="description"
          item-value="place_id"
          @set-value-menu="getValueMenu"
          @search-input="getValueAutocompleted"
        />
      </v-col>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-list two-line class="py-0">
          <v-list-item @click="selectMap()">
            <v-list-item-avatar size="25">
              <img src="@/assets/images/svg/marker_default.svg">
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ $t('select_with_map') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-bottom-sheet v-model="sheet.select_location" persistent :content-class="'showFull'">
      <v-sheet style="height: 100%">
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <h2 class="headline">
                <span class="font-weight-bold d-flex align-center">
                  <v-icon class="mr-3 black--text" @click="closeSheetSelectLocation()">
                    mdi-close
                  </v-icon>
                  {{ $t('select_with_map') }}
                </span>
              </h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <l-map ref="map" v-resize="onResize" style="height: calc(100vh - 80px); width: calc(100% + 24px); left: -12px;" :zoom="16" :center="center">
                <l-tile-layer :url="url" :attribution="attribution" />
                <l-marker :lat-lng="markerLatLng" draggable @update:lat-lng="updateCoordinates" />
              </l-map>
              <div class="menu__select-loacation">
                <div class="menu__select-loacation-wrapper">
                  <v-card>
                    <v-card-text>
                      <h5 class="subtitle-1 font-weight-bold text--primary">
                        {{ $t('select_delivery_location') }}
                      </h5>
                      <v-list>
                        <v-list-item>
                          <v-list-item-avatar size="20">
                            <img src="@/assets/images/svg/marker.svg">
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="text-two-line __white-space-normal">
                              {{ data_location.address }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </div>
                <v-btn color="primary" block x-large @click="selectNewLocation()">
                  {{ $t('next_3') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import L from 'leaflet'
import { debounce } from 'debounce'
import {
  autoComplete as autoCompleteMaps,
  placeDetail as placeDetailMaps,
  geoCodeByLatLng as geoCodeByLatLngMaps,
  distanceMatrix as distanceMatrixMaps
} from '@/api/maps'
import {
  getDataShippingV2
} from '@/api/order'
import LAutocompleted from '@/components/modules/autocompleted/Index'
export default {
  components: {
    LAutocompleted
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 15,
      center: [0, 0],
      markerLatLng: [0, 0],
      autocompleteOptions: {
        componentRestrictions: {
          country: [
            'id'
          ]
        }
      },
      data_location: {
        address: '',
        postal_code: '',
        city: '',
        state: '',
        country: '',
        lat: 0,
        lng: 0
      },
      sheet: {
        select_location: false
      },
      dataCheckoutDelivery: {
        shipping_address: '',
        shipping_delivery_type: 1,
        shipping_time: '',
        shipping_radius: 0,
        item: []
      },
      list_address: [],
      place_id: null,
      search: null,
      open_autocompleted: false,
      params_google: {
        types: 'geocode|establishment',
        radius: 500,
        location: '',
        components: encodeURIComponent('country:ID')
      },
      list_shipping: []
    }
  },
  watch: {
    'place_id': function(newItem) {
      if (typeof newItem !== 'undefined') {
        this.selectAddress(newItem)
      }
    },
    search: debounce(async function(val) {
      console.log('test')
      this.list_address = []
      if (val && val !== '') {
        const params = {
          address: val,
          params: Object.keys(this.params_google).map(key => key + '=' + this.params_google[key]).join('&')
        }
        this.getListAddress(params)
        this.open_autocompleted = true
      } else {
        this.list_address = []
        this.open_autocompleted = false
      }
    }, 2000)
  },
  mounted() {
    if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY'))) this.dataCheckoutDelivery = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY'))
    if (!('geolocation' in navigator)) {
      console.log('Geolocation is not available.')
    }
    navigator.geolocation.getCurrentPosition(pos => {
      this.params_google.location = encodeURIComponent(pos.coords.latitude + ', ' + pos.coords.longitude)
    }, () => {
      this.$store.state.block_location = true
    })
  },
  methods: {
    async getListDeliv(lat, lon) {
      try {
        const params = {
          shipping_lat: lat,
          shipping_lon: lon,
          item: this.dataCheckoutDelivery.item
        }
        const { data } = await getDataShippingV2(params)
        this.$store.state.loading_axios = false
        this.list_shipping = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    getValueAutocompleted(e) {
      this.search = e
    },
    getValueMenu(e) {
      this.open_autocompleted = e
    },
    async getListAddress(params) {
      if (!this.$isEmpty(params)) {
        try {
          const { data } = await autoCompleteMaps(params)
          this.$store.state.loading_axios = false
          data.predictions.map(item => {
            this.list_address.push(item)
          })
        } catch (e) {
          this.list_address = []
        }
      }
    },
    async selectAddress() {
      if (this.place_id) {
        try {
          const { data } = await placeDetailMaps(this.place_id)
          this.$store.state.loading_axios = false
          this.setPlace(data.result)
        } catch (e) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    onResize() {
      this.$refs.map.mapObject._onResize()
    },
    goBack() {
      this.$router.go(-1)
    },
    async selectMap() {
      this.sheet.select_location = true
      await this.getLatLng()
    },
    closeSheetSelectLocation() {
      this.sheet.select_location = false
    },
    async setMarker(lat, lng) {
      const form = {
        lat: lat,
        lon: lng
      }
      this.getAddress(form).then((data) => {
        this.data_location.address = data
      })
      this.data_location.lat = lat
      this.data_location.lng = lng
    },
    async getAddress(dataLocation) {
      try {
        const { data } = await geoCodeByLatLngMaps(dataLocation)
        this.$store.state.loading_axios = false
        return data.results[0].formatted_address
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
        return ''
      }
    },
    async getLatLng() {
      if (!('geolocation' in navigator)) {
        console.log('Geolocation is not available.')
      }
      navigator.geolocation.getCurrentPosition(pos => {
        this.setMarker(pos.coords.latitude, pos.coords.longitude)
        this.$refs.map.setCenter([pos.coords.latitude, pos.coords.longitude])
        this.markerLatLng = L.latLng(pos.coords.latitude, pos.coords.longitude)
      }, () => {
        this.$store.state.block_location = true
      })
    },
    updateCoordinates: debounce(async function(location) {
      await this.setMarker(location.lat, location.lng)
      this.$refs.map.setCenter([location.lat, location.lng])
    }, 2000),
    async setPlace(place) {
      var location_lat
      var location_lng
      if (this.$store.state.selected_outlet) {
        location_lat = this.$store.state.selected_outlet.location_lat
        location_lng = this.$store.state.selected_outlet.location_lon
      } else {
        location_lat = this.$store.state.selected_store.location_lat
        location_lng = this.$store.state.selected_store.location_lon
      }
      const _this = this
      const form = {
        origin_lat: Number(location_lat),
        origin_lon: Number(location_lng),
        destination: [
          {
            lat: place.geometry.location.lat,
            lon: place.geometry.location.lng
          }
        ]
      }
      this.calcDistance(form).then(async(result) => {
        if (result.status === 'OK') {
          if (result.rows[0].elements[0].status !== 'ZERO_RESULTS') {
            _this.$set(_this.dataCheckoutDelivery, 'shipping_radius', Math.ceil(result.rows[0].elements[0].distance.value / 1000))
            _this.dataCheckoutDelivery.shipping_address = place.formatted_address
            _this.dataCheckoutDelivery.shipping_lat = place.geometry.location.lat
            _this.dataCheckoutDelivery.shipping_lon = place.geometry.location.lng
            if (_this.dataCheckoutDelivery.shipping_delivery_type && _this.dataCheckoutDelivery.shipping_delivery_type === 2) {
              await _this.getListDeliv(_this.dataCheckoutDelivery.shipping_lat, _this.dataCheckoutDelivery.shipping_lon)
              const x = _this.list_shipping.findIndex((data) => data.rate_id === _this.dataCheckoutDelivery.shipping_courier_id)
              if (x !== -1) {
                _this.dataCheckoutDelivery.shipping_cost = _this.list_shipping[x].final_price
              } else {
                // _this.$store.state.outside_radius = true
                _this.$store.state.show_error = true
                _this.$store.state.error_message = 'Maaf, lokasi pengiriman yang Anda pilih berada di luar jangkauan'
                _this.$store.state.error_type = 400
                return
              }
            }
            _this.$store.dispatch('saveDataCartDelivery', _this.dataCheckoutDelivery)
            _this.$router.go(-1)
          } else {
            _this.$store.state.outside_radius = true
            _this.$store.state.show_error = true
            _this.$store.state.error_message = 'Melebihi jangkauan'
            _this.$store.state.error_type = 400
          }
        } else {
          _this.$store.state.show_error = true
          _this.$store.state.error_message = 'Melebihi jangkauan'
          _this.$store.state.error_type = 400
        }
      })
    },
    async selectNewLocation() {
      var location_lat
      var location_lng
      if (this.$store.state.selected_outlet) {
        location_lat = this.$store.state.selected_outlet.location_lat
        location_lng = this.$store.state.selected_outlet.location_lon
      } else {
        location_lat = this.$store.state.selected_store.location_lat
        location_lng = this.$store.state.selected_store.location_lon
      }
      const _this = this
      const form = {
        origin_lat: Number(location_lat),
        origin_lon: Number(location_lng),
        destination: [
          {
            lat: this.data_location.lat,
            lon: this.data_location.lng
          }
        ]
      }
      this.calcDistance(form).then(async(result) => {
        if (result.status === 'OK') {
          if (result.rows[0].elements[0].status !== 'ZERO_RESULTS') {
            _this.$set(_this.dataCheckoutDelivery, 'shipping_radius', Math.ceil(result.rows[0].elements[0].distance.value / 1000))
            _this.dataCheckoutDelivery.shipping_address = _this.data_location.address
            _this.dataCheckoutDelivery.shipping_lat = _this.data_location.lat
            _this.dataCheckoutDelivery.shipping_lon = _this.data_location.lng
            if (_this.dataCheckoutDelivery.shipping_delivery_type && _this.dataCheckoutDelivery.shipping_delivery_type === 2) {
              await _this.getListDeliv(_this.dataCheckoutDelivery.shipping_lat, _this.dataCheckoutDelivery.shipping_lon)
              const x = _this.list_shipping.findIndex((data) => data.rate_id === _this.dataCheckoutDelivery.shipping_courier_id)
              if (x !== -1) {
                _this.dataCheckoutDelivery.shipping_cost = _this.list_shipping[x].final_price
              } else {
                // _this.$store.state.outside_radius = true
                _this.$store.state.show_error = true
                _this.$store.state.error_message = 'Maaf, lokasi pengiriman yang Anda pilih berada di luar jangkauan'
                _this.$store.state.error_type = 400
                return
              }
            }
            _this.$store.dispatch('saveDataCartDelivery', _this.dataCheckoutDelivery)
            _this.$router.go(-1)
          } else {
            _this.$store.state.outside_radius = true
            _this.$store.state.show_error = true
            _this.$store.state.error_message = 'Melebihi jangkauan'
            _this.$store.state.error_type = 400
          }
        } else {
          _this.$store.state.show_error = true
          _this.$store.state.error_message = 'Melebihi jangkauan'
          _this.$store.state.error_type = 400
        }
      })
    },
    async calcDistance(dataDistance) {
      try {
        const { data } = await distanceMatrixMaps(dataDistance)
        this.$store.state.loading_axios = false
        if (data.status === 'ZERO_RESULTS') {
          const astra_outlet = this.$store.state.store_astra
          const tmii_outlet = this.$store.state.store_tmii
          const url_id = this.$store.state.url_domain

          if (tmii_outlet.indexOf(url_id) !== -1) {
            window.location.href = 'https://order.kulinertmii.id'
          } else if (astra_outlet.indexOf(url_id) !== -1) {
            window.location.href = 'https://zestloungemenaraastra.myolsera.com'
          } else {
            this.$router.push({ name: 'home' }).catch(() => {})
          }
        } else {
          return data
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    }
  }
}
</script>
